import type { ReactNode } from "react";

export type BadgeTone = "blue" | "emerald" | "amber" | "rose" | "slate";

type Props = {
  tone?: BadgeTone;
  children: ReactNode;
};

const TONE_CLASSES: Record<BadgeTone, string> = {
  blue: "bg-blue-50 text-blue-800 ring-blue-200",
  emerald: "bg-emerald-50 text-emerald-800 ring-emerald-200",
  amber: "bg-amber-50 text-amber-800 ring-amber-200",
  rose: "bg-rose-50 text-rose-800 ring-rose-200",
  slate: "bg-slate-100 text-slate-700 ring-slate-200",
};

export function Badge({ tone = "slate", children }: Props) {
  return (
    <span
      className={
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset " +
        TONE_CLASSES[tone]
      }
    >
      {children}
    </span>
  );
}
